import { NewsItemWrapper } from "./styled"
import { FaRegCalendarAlt } from "react-icons/fa";
import Image from "components/Image";
import { Link } from "react-router-dom";

const NewsItem = ({ slug, thumbnail, name, date }) => {
    return (
        <NewsItemWrapper>
            <Link to={`/news/${slug}`}>
                <div className="image">
                    <Image src={thumbnail} />
                </div>
                <div className="title">
                    <h1>{name} </h1>
                </div>
                <div className="date">
                    <i><FaRegCalendarAlt /></i>
                    <span>{date.slice(0, 10)}</span>
                </div>
            </Link>
        </NewsItemWrapper>
    )
}

export default NewsItem